import { Link } from 'react-router-dom';
import ProjectPlaceholder from './ProjectPlaceholder';

interface ProjectCardProps {
  project: {
    slug: string;
    title: string;
    category: string;
    tags: string[];
    description: string;
    gradient: string;
    letter: string;
    year: string;
    images?: string[];
  };
  index?: number;
}

const pillColorClasses: Record<string, string> = {
  'Mobile Apps': 'pill--green',
  'Desktop Apps': 'pill--blue',
  'Web Design': 'pill--orange',
  'Logo Design': 'pill--purple',
  'Reddit Design': 'pill--red',
  Mobile: 'pill--green',
  Desktop: 'pill--blue',
  Web: 'pill--orange',
  Logo: 'pill--purple',
  Reddit: 'pill--red',
};

export default function ProjectCard({ project, index }: ProjectCardProps) {
  const hasImages = project.images && project.images.length > 0;
  const primaryImage = hasImages ? project.images![0] : null;

  return (
    <Link
      to={`/work/${project.slug}`}
      className={`project-card card${index !== undefined ? ' animate-fade-in-up' : ''}`}
      style={index !== undefined ? { animationDelay: `${index * 0.08}s` } : undefined}
    >
      <div className="project-card__image">
        {primaryImage ? (
          <img 
            src={primaryImage} 
            alt={project.title}
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover',
              borderRadius: 'var(--radius-comfortable) var(--radius-comfortable) 0 0'
            }}
            loading="lazy"
          />
        ) : (
          <ProjectPlaceholder gradient={project.gradient} letter={project.letter} size="md" />
        )}
        <span className="project-card__play">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
        </span>
      </div>
      <div className="project-card__content">
        <div className="project-card__header">
          <h3 className="project-card__title h-4">{project.title}</h3>
          <span className="project-card__year caption">{project.year}</span>
        </div>
        <p className="project-card__category caption-bold">{project.category}</p>
        {project.tags.length > 0 && (
          <div className="project-card__tags">
            {project.tags.slice(0, 3).map((tag) => (
              <span key={tag} className={`pill ${pillColorClasses[tag] || ''}`}>
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}
